import { styled } from 'styled-components'

import type { ContractDto } from '@b-stock/contract-api-client'
import type { BidPrecision } from '@b-stock/fe-core/bstock-next/hooks'

import type { OfferingItemRow } from '../types'
import { OfferingFormTile } from './OfferingFormTile'

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`

export const OfferingFormTiles = ({
  bidPrecision,
  contract,
  currency = 'USD',
  rows,
}: {
  bidPrecision: BidPrecision
  contract?: ContractDto | null
  currency?: string
  rows: OfferingItemRow[]
}) => (
  <Body>
    {rows.map((row, index) => (
      <OfferingFormTile
        key={row.item._id}
        bidPrecision={bidPrecision}
        contract={contract}
        currency={currency}
        row={row}
        rowIndex={index}
      />
    ))}
  </Body>
)
